import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupListComponent } from './group-list/group-list.component';
import { GroupFormComponent } from './group-form/group-form.component';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { AppRoutingModule } from '../app-routing.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { GroupViewComponent } from './group-view/group-view.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MaterialModule } from '../material/material.module';
import { PageTitleComponent } from '../components/page-title/page-title.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [GroupListComponent, GroupFormComponent, GroupViewComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatTooltipModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatDialogModule,
    AppRoutingModule,
    MatPaginatorModule,
    ScrollingModule,
    MatButtonModule,
    MaterialModule,
    ComponentsModule,
  ],
})
export class GroupModule {}
